import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ImageComponent } from './components/image/image.component'
import { DateFormatPipe } from './pipes/date-format/date-format.pipe'
import { MoneyFormatterPipe } from './pipes/money-formatter/money-formatter.pipe'
import { ToUnderscorePipe } from './pipes/to-underscore/to-underscore.pipe'
import { TypeOfPipe } from './pipes/type-of/type-of.pipe'
import { ReplacePipe } from './pipes/replace/replace.pipe'
import { GtmDirective } from './directives/gtm.directive'
import { PermissionsDirective } from './directives/permissions.directive'
import { IframeContainerComponent } from './components/iframe-container/iframe-container.component'
import { NzSpinModule } from 'ng-zorro-antd/spin'
import { NumberFormatterPipe } from './pipes/number-formatter/number-formatter.pipe'
import { ModelMappingPipe } from './pipes/model-mapping/model-mapping.pipe'


const components = [
  ImageComponent,
  DateFormatPipe,
  MoneyFormatterPipe,
  ToUnderscorePipe,
  TypeOfPipe,
  ReplacePipe,
  GtmDirective,
  PermissionsDirective,
  IframeContainerComponent,
  NumberFormatterPipe,
  ModelMappingPipe
]


@NgModule({
  declarations: [ ...components ],
  exports: [ ...components ],
  imports: [
    CommonModule,
    NzSpinModule
  ]
})
export class SharedModule {
}
